//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import withZoom from '../Zoom/withZoom';
import Tick from '../../icons/CreationTick.svg';
import { useTranslation } from 'react-i18next';

interface Step {
  id: number;
  name: string;
}

interface LandingMiniNavProps {
  step: number;
  steps: Step[];
  isZoomedIn?: boolean;
}

const LandingMiniNav: React.FC<LandingMiniNavProps> = ({ step, steps }) => {
  const { t } = useTranslation();

  return (
    <div id="landing-mini-nav" data-testid="landing-mini-nav" className="mb-6">
      <div
        id="form-nav"
        data-testid="form-nav"
        className="flex items-start gap-2"
      >
        {steps.map((stepItem, index) => {
          const stepNum = index + 1;
          const isActive = stepNum === step;
          const isCompleted = stepNum < step;

          return (
            <div
              key={stepItem.id}
              id="nav-items"
              data-testid="nav-items"
              className="relative flex-1"
            >
              <div
                id="id-landing-nav-step-bar"
                data-testid="landing-nav-step-bar"
                className={`absolute inset-x-0 top-0 h-1 rounded-full ${
                  isActive || isCompleted ? 'bg-brand-blue' : 'bg-carbon-border'
                }`}
              />
              <div
                id="id-landing-nav-step-content"
                data-testid="landing-nav-step-content"
                className="flex items-center gap-2 pt-2"
              >
                <div
                  id="id-landing-nav-step-number"
                  data-testid="landing-nav-step-number"
                  className={`flex size-8 shrink-0 items-center justify-center rounded-full text-sm font-medium ${
                    isActive || isCompleted
                      ? 'bg-brand-blue text-white'
                      : 'bg-carbon-border text-carbon-dark dark:bg-carbon-darkBorderSurface dark:text-white'
                  }`}
                >
                  {isCompleted ? (
                    <img src={Tick} alt={t('completed')} className="size-4" />
                  ) : (
                    stepNum
                  )}
                </div>
                <span
                  id="id-landing-nav-step-name"
                  data-testid="landing-nav-step-name"
                  className={`whitespace-nowrap text-xs leading-tight ${
                    isActive || isCompleted
                      ? 'font-medium text-carbon-dark dark:text-white'
                      : 'text-carbon-textSecondary dark:text-carbon-textMuted'
                  }`}
                >
                  {stepItem.name}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default withZoom(LandingMiniNav, 200);
